export default function OpenRight({ className, onClick, style }) {
  return (
    <svg
      width="45"
      height="34"
      viewBox="0 0 45 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      style={style}
    >
      <rect
        opacity="0.75"
        x="9.5"
        y="7.5"
        width="9"
        height="21"
        rx="0.5"
        stroke="currentColor"
      />
      <path
        opacity="0.75"
        d="M37.5 17.5L33.5 13.5M37.5 17.5L33.5 21.5M37.5 17.5H25"
        stroke="currentColor"
      />
    </svg>
  );
}
